// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-list.table-list {
  border: 1px solid #c1bebe;
}

::ng-deep .plan-details-day plan-detail-clickable-header {
  display: none;
}

.plan-detail-container {
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
}

.plan-detail-container .slider {
  flex: 1 1 auto;
}

.plan-detail-container ag-grid-angular {
  position: absolute;
  height: 100%;
  width: 100%;
}

plan-detail-chart {
  height: calc(100vh - 230px);
  display: block;
}

.contactTypeDropDown {
  display: inline-block;
  width: 270px;
  text-align: left;
}

.row.slider {
  flex-wrap: nowrap;
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: 1px solid #c1bebe;
}

.slide {
  width: 100%;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  flex-shrink: 0;
  /* transform: translateX(-100%); */
  transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);
  flex-basis: auto;
}

.slider.alternate .slide {
  transform: translateX(-100%);
}

.icon {
  font-size: 20px;
  vertical-align: top;
  margin-right: 0.25rem;
}

:host ::ng-deep button.btn-lg.no-right-margin {
  margin-right: 0;
}
:host ::ng-deep .breadcrumb {
  background-color: transparent;
  margin-bottom: 5px;
  padding: 0;
  list-style: none;
  border-radius: 4px;
  font-size: 12px;
}
:host ::ng-deep .breadcrumb > li {
  display: inline-block;
}
:host ::ng-deep .breadcrumb > li a {
  color: #0094D1;
}
:host ::ng-deep #btn-action button {
  min-width: 40px;
  padding: 0;
}
:host ::ng-deep #dropdownSettings {
  min-width: 0;
}
:host ::ng-deep #dropdownSettings:after {
  display: none;
}

.search-box {
  padding: 0;
}

.btn-rect {
  min-width: 0;
  width: 40px;
}

:host ::ng-deep .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #fff;
  border-color: #dae2e8;
  box-shadow: 0 0 0 0 transparent;
}

:host ::ng-deep .dropdown-menu {
  border-radius: 0;
  padding: 0;
}
:host ::ng-deep .dropdown-menu .dropdown-item {
  color: #888;
  padding: 0.75rem 0.75rem;
  vertical-align: middle;
  font-size: 14px;
  cursor: pointer;
}
:host ::ng-deep .dropdown-menu .dropdown-item svg {
  fill: #888;
  margin-right: 0.25rem;
}
:host ::ng-deep .dropdown-menu .dropdown-item[disabled] {
  opacity: 0.5;
}
:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover {
  background-color: #007db8;
  color: #FFF;
}
:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover svg {
  fill: #FFF;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/plan-detail/plan-detail.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/plan/plan-detail/plan-detail.component.scss"],"names":[],"mappings":"AAIA;EACE,yBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;ACHF;;ADKA;EACE,cAAA;ACFF;;ADIA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;ACDF;;ADIA;EACE,2BAAA;EACA,cAAA;ACDF;;ADGA;EACE,qBAAA;EACA,YAAA;EACA,gBAAA;ACAF;;ADEA;EACE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;ACCF;;ADIA;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EAIA,yDAAA;EACA,gBAAA;ACDF;;ADGA;EACE,4BAAA;ACAF;;ADEA;EACE,eAAA;EACA,mBAAA;EACA,qBAAA;ACCF;;ADKM;EACE,eAAA;ACFR;ADOE;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;ACLJ;ADMI;EACE,qBAAA;ACJN;ADKM;EACE,cAAA;ACHR;ADSI;EACE,eAAA;EACA,UAAA;ACPN;ADUE;EACE,YAAA;ACRJ;ADSI;EAAS,aAAA;ACNb;;ADWA;EACE,UAAA;ACRF;;ADWA;EACE,YAAA;EACA,WAAA;ACRF;;ADWA;EACE,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,+BAAA;ACRF;;ADUA;EACE,gBAAA;EACA,UAAA;ACPF;ADSE;EACE,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;ACPJ;ADSI;EACE,UAAA;EACA,qBAAA;ACPN;ADSI;EACE,YAAA;ACPN;ADSI;EACE,yBAAA;EACA,WAAA;ACPN;ADQM;EACE,UAAA;ACNR","sourcesContent":["@import \"src/assets/wfm_variables\";\n\n$headerDarkTextColor: #2E2E2E;\n\n.plan-list.table-list {\n  border: 1px solid $dark-border-color;\n}\n\n::ng-deep .plan-details-day plan-detail-clickable-header{\n  display: none;\n}\n\n.plan-detail-container{\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  padding-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.plan-detail-container .slider{\n  flex: 1 1 auto;\n}\n.plan-detail-container ag-grid-angular{\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\nplan-detail-chart{\n  height: calc(100vh - 230px);\n  display: block;\n}\n.contactTypeDropDown{\n  display: inline-block;\n  width: 270px;\n  text-align: left;\n}\n.row.slider{\n  flex-wrap: nowrap;\n  overflow: hidden;\n  padding:0;\n  margin:0;\n  border: 1px solid $dark-border-color;\n}\n.slide.active{\n\n}\n.slide{\n  width: 100%;\n  padding:0;\n  margin:0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  /* transform: translateX(-100%); */\n  -webkit-transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  -moz-transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  -o-transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  transition: all 0.8s cubic-bezier(.46,.03,.52,.96);\n  flex-basis: auto;\n}\n.slider.alternate .slide{\n  transform: translateX(-100%);\n}\n.icon{\n  font-size: 20px;\n  vertical-align: top;\n  margin-right:.25rem;\n}\n:host ::ng-deep {\n\n  button {\n    &.btn-lg {\n      &.no-right-margin {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .breadcrumb {\n    background-color: transparent;\n    margin-bottom: 5px;\n    padding: 0;\n    list-style: none;\n    border-radius: 4px;\n    font-size: 12px;\n    & > li {\n      display: inline-block;\n      a {\n        color: #0094D1;\n      }\n    }\n  }\n\n  #btn-action {\n    button {\n      min-width: 40px;\n      padding: 0;\n    }\n  }\n  #dropdownSettings {\n    min-width: 0;\n    &:after {display: none;}\n  }\n\n}\n\n.search-box {\n  padding: 0;\n}\n\n.btn-rect{\n  min-width: 0;\n  width:40px;\n}\n\n:host ::ng-deep .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0 0 0 0 transparent;\n}\n:host ::ng-deep .dropdown-menu {\n  border-radius: 0;\n  padding: 0;\n\n  .dropdown-item {\n    color: #888;\n    padding: 0.75rem .75rem;\n    vertical-align: middle;\n    font-size: 14px;\n    cursor: pointer;\n\n    svg {\n      fill: #888;\n      margin-right: .25rem;\n    }\n    &[disabled] {\n      opacity: 0.5;\n    }\n    &:not([disabled]):hover {\n      background-color: #007db8;\n      color: #FFF;\n      svg {\n        fill: #FFF;\n      }\n    }\n  }\n}\n\n",".plan-list.table-list {\n  border: 1px solid #c1bebe;\n}\n\n::ng-deep .plan-details-day plan-detail-clickable-header {\n  display: none;\n}\n\n.plan-detail-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  padding-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.plan-detail-container .slider {\n  flex: 1 1 auto;\n}\n\n.plan-detail-container ag-grid-angular {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\nplan-detail-chart {\n  height: calc(100vh - 230px);\n  display: block;\n}\n\n.contactTypeDropDown {\n  display: inline-block;\n  width: 270px;\n  text-align: left;\n}\n\n.row.slider {\n  flex-wrap: nowrap;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #c1bebe;\n}\n\n.slide {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  flex-grow: 1;\n  flex-shrink: 0;\n  /* transform: translateX(-100%); */\n  -webkit-transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  -moz-transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  -o-transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  transition: all 0.8s cubic-bezier(0.46, 0.03, 0.52, 0.96);\n  flex-basis: auto;\n}\n\n.slider.alternate .slide {\n  transform: translateX(-100%);\n}\n\n.icon {\n  font-size: 20px;\n  vertical-align: top;\n  margin-right: 0.25rem;\n}\n\n:host ::ng-deep button.btn-lg.no-right-margin {\n  margin-right: 0;\n}\n:host ::ng-deep .breadcrumb {\n  background-color: transparent;\n  margin-bottom: 5px;\n  padding: 0;\n  list-style: none;\n  border-radius: 4px;\n  font-size: 12px;\n}\n:host ::ng-deep .breadcrumb > li {\n  display: inline-block;\n}\n:host ::ng-deep .breadcrumb > li a {\n  color: #0094D1;\n}\n:host ::ng-deep #btn-action button {\n  min-width: 40px;\n  padding: 0;\n}\n:host ::ng-deep #dropdownSettings {\n  min-width: 0;\n}\n:host ::ng-deep #dropdownSettings:after {\n  display: none;\n}\n\n.search-box {\n  padding: 0;\n}\n\n.btn-rect {\n  min-width: 0;\n  width: 40px;\n}\n\n:host ::ng-deep .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #fff;\n  border-color: #dae2e8;\n  box-shadow: 0 0 0 0 transparent;\n}\n\n:host ::ng-deep .dropdown-menu {\n  border-radius: 0;\n  padding: 0;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item {\n  color: #888;\n  padding: 0.75rem 0.75rem;\n  vertical-align: middle;\n  font-size: 14px;\n  cursor: pointer;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item svg {\n  fill: #888;\n  margin-right: 0.25rem;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item[disabled] {\n  opacity: 0.5;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover {\n  background-color: #007db8;\n  color: #FFF;\n}\n:host ::ng-deep .dropdown-menu .dropdown-item:not([disabled]):hover svg {\n  fill: #FFF;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
